import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import type {
  FeedRequest,
  FeedResponse,
  FeedTradeResponse,
  FeedWantResponse,
} from 'types/interfaces/feed';

export const feedApi = createApi({
  reducerPath: 'feedApi',
  baseQuery,
  tagTypes: ['Feed'],
  endpoints: (builder) => ({
    getFeed: builder.query<FeedResponse, FeedRequest>({
      query: ({ filter, page = 1, pageSize = 20, card, window = '14d' }) => {
        const params = new URLSearchParams({
          window,
          filter,
          page: String(page),
          pageSize: String(pageSize),
        });
        const trimmed = card?.trim();
        if (trimmed) {
          params.set('card', trimmed);
        }
        return {
          url: `/feed?${params.toString()}`,
          method: 'GET',
          requiresAuth: true,
        };
      },
      providesTags: (_result, _err, { filter }) => [{ type: 'Feed', id: filter }],
    }),
  }),
});

export const { useGetFeedQuery } = feedApi;

export type { FeedTradeResponse, FeedWantResponse };
